import OrganizationPage from "./OrganizationPageRoot.vue"
export default OrganizationPage
